import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StoresRoutingModule } from './stores-routing.module';
import { NavbarModule } from '../navbar/navbar.module';
import { ToolbarModule } from '../toolbar/toolbar.module';
import { TranslateModule } from '@ngx-translate/core';
import { LoadingModule } from '../loading/loading.module';
import { SharedModule } from '../shared/shared.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { QRCodeModule } from 'angularx-qrcode';

import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatTableModule } from '@angular/material/table';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatMenuModule } from '@angular/material/menu';

import { StoresComponent } from './stores/stores.component';
import { StoresHeaderComponent } from './stores-header/stores-header.component';
import { StoresDataComponent } from './stores-data/stores-data.component';
import { StoresEmptyComponent } from './stores-empty/stores-empty.component';
import { StoresDataTableComponent } from './stores-data-table/stores-data-table.component';
import { StoresSummaryComponent } from './stores-summary/stores-summary.component';
import { StoresFiltersComponent } from './stores-filters/stores-filters.component';
import { StoresFilterDialogComponent } from './stores-filter-dialog/stores-filter-dialog.component';
import { StoresToggleDialogComponent } from './stores-toggle-dialog/stores-toggle-dialog.component';
import { StoresQrCodeDialogComponent } from './stores-qr-code-dialog/stores-qr-code-dialog.component';
import { StoresPluginCredentialsDialogComponent } from './stores-plugin-credentials-dialog/stores-plugin-credentials-dialog.component';
import { StoresTicketDialogComponent } from './stores-ticket-dialog/stores-ticket-dialog.component';
import { StoresPaymentMethodsDialogComponent } from './stores-payment-methods-dialog/stores-payment-methods-dialog.component';
import { StoresAllowedStepsDialogComponent } from './stores-allowed-steps-dialog/stores-allowed-steps-dialog.component';
import { StoreHeaderBulkCreationDialogComponent } from './stores-header-bulk-creation-dialog/stores-header-bulk-creation-dialog.component';
import { StoresSalesNetworkDialogComponent } from './stores-sales-network-dialog/stores-sales-network-dialog.component';

@NgModule({
  declarations: [
    StoresComponent,
    StoresHeaderComponent,
    StoresDataComponent,
    StoresEmptyComponent,
    StoresDataTableComponent,
    StoresSummaryComponent,
    StoresFiltersComponent,
    StoresFilterDialogComponent,
    StoresToggleDialogComponent,
    StoresQrCodeDialogComponent,
    StoresPluginCredentialsDialogComponent,
    StoresTicketDialogComponent,
    StoresPaymentMethodsDialogComponent,
    StoresAllowedStepsDialogComponent,
    StoreHeaderBulkCreationDialogComponent,
    StoresSalesNetworkDialogComponent,
  ],
  imports: [
    CommonModule,
    StoresRoutingModule,
    NavbarModule,
    ToolbarModule,
    TranslateModule,
    LoadingModule,
    SharedModule,
    ReactiveFormsModule,
    FormsModule,
    QRCodeModule,
    MatInputModule,
    MatFormFieldModule,
    MatSelectModule,
    MatProgressSpinnerModule,
    MatIconModule,
    MatButtonModule,
    MatTooltipModule,
    MatTableModule,
    MatSlideToggleModule,
    MatAutocompleteModule,
    MatCheckboxModule,
    MatMenuModule,
  ],
})
export class StoresModule {}
